const MEASURE_KEYWORDS = [
  "sales",
  "sale",
  "revenue",
  "profit",
  "value",
  "amount",
  "price",
  "cost",
  "quantity",
  "qty",
  "income",
  "expense",
  "salary",
  "score",
  "total",
  "balance"
];

const TIME_KEYWORDS = [
  "date",
  "day",
  "week",
  "month",
  "quarter",
  "year",
  "time"
];

const ID_KEYWORDS = [
  "id",
  "_id",
  "code",
  "postcode",
  "postal",
  "zipcode",
  "zip"
];

const PERSON_KEYWORDS = [
  "name",
  "customer",
  "employee",
  "person",
  "rep",
  "manager",
  "staff",
  "owner",
  "client"
];

export function buildDatasetSchema(data = []) {

  const schema = {
    columns: [],
    measures: [],
    dimensions: [],
    time: [],
    ids: [],
    people: [],
    aliases: {},
    columnInfo: {}
  };

  if (!Array.isArray(data) || !data.length) {
    return schema;
  }

  schema.columns = Object.keys(data[0]);

  for (const column of schema.columns) {

    const lower = column.toLowerCase();

    const words = column
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2") // camelCase -> camel Case
      .replace(/_/g, " ")
      .replace(/-/g, " ")
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean);

    const values = data
      .map(r => r[column])
      .filter(
        v =>
          v !== null &&
          v !== undefined &&
          v !== ""
      );

    const uniqueCount = new Set(values).size;

    const numericCount = values.filter(
      v => !isNaN(Number(v))
    ).length;

    const numericRatio =
      values.length === 0
        ? 0
        : numericCount / values.length;

    const isMostlyNumeric =
      numericRatio >= 0.9;

    const isMeasureKeyword =
      MEASURE_KEYWORDS.some(keyword =>
        words.includes(keyword)
      );

    const isTime =
      TIME_KEYWORDS.some(keyword =>
        words.includes(keyword)
      );

    const isID =
      ID_KEYWORDS.some(keyword =>
        words.includes(keyword)
      );

    const isPerson =
      PERSON_KEYWORDS.some(keyword =>
        words.includes(keyword)
      );

    //--------------------------------------------------
    // CLASSIFICATION
    //--------------------------------------------------

    if (isTime) {

      schema.time.push(column);

      schema.dimensions.push(column);

    }

    else if (isID) {

      schema.ids.push(column);

      schema.dimensions.push(column);

    }

    else if (isMeasureKeyword && !isPerson) {

      schema.measures.push(column);

    }

    else {

      schema.dimensions.push(column);

      if (isPerson) {
        schema.people.push(column);
      }

    }

    //--------------------------------------------------
    // COLUMN INFO
    //--------------------------------------------------

    schema.columnInfo[column] = {

      numeric: isMostlyNumeric,

      measure: schema.measures.includes(column),

      dimension: schema.dimensions.includes(column),

      time: schema.time.includes(column),

      id: schema.ids.includes(column),

      person: schema.people.includes(column),

      unique: uniqueCount,

      nulls: data.length - values.length

    };

    //--------------------------------------------------
    // ALIASES
    //--------------------------------------------------

    schema.aliases[lower] = column;

    if (lower.includes("value")) {

      schema.aliases.sales = column;
      schema.aliases.sale = column;
      schema.aliases.revenue = column;
      schema.aliases.amount = column;

    }

    if (lower.includes("profit")) {

      schema.aliases.profit = column;

    }

    if (lower.includes("price")) {

      schema.aliases.price = column;

    }

    if (lower.includes("cost")) {

      schema.aliases.cost = column;

    }

    if (lower.includes("quantity")) {

      schema.aliases.quantity = column;
      schema.aliases.qty = column;

    }

    if (lower.includes("postcode")) {

      schema.aliases.postcode = column;
      schema.aliases.zip = column;
      schema.aliases.zipcode = column;

    }

    if (lower.includes("city")) {

      schema.aliases.city = column;

    }

    if (lower.includes("country")) {

      schema.aliases.country = column;

    }

    if (lower.includes("region")) {

      schema.aliases.region = column;

    }

    if (lower.includes("state")) {

      schema.aliases.state = column;

    }

    if (lower.includes("category")) {

      schema.aliases.category = column;

    }

    if (lower.includes("name")) {

      schema.aliases.name = column;

    }

    if (lower.includes("customer")) {

      schema.aliases.customer = column;

    }

    if (lower.includes("product")) {

      schema.aliases.product = column;

    }

    if (lower.includes("year")) {

      schema.aliases.year = column;

    }

    if (lower.includes("month")) {

      schema.aliases.month = column;

    }

    if (lower.includes("date")) {

      schema.aliases.date = column;

    }

  }

  return schema;

}